// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"6c039f8e","208":"c3ae0d5b","315":"3eed911a","327":"f5fd9749","409":"8ef4629c","631":"faf7161c","771":"195bd1c9","774":"9b9d1fcb","787":"88dfdeb5"}[chunkId] + ".chunk.js";
};